import { Grid, Typography } from '@mui/material'
import React from 'react'
import dealershipBrandsDict from '../../../constants/dealershipBrands'

const CustomerView = ({ data }) => {
  return (
    <>
      {(data.user || data._id) && (
        <Grid item xs={12}>
          <Typography variant='subtitle1'>User ID</Typography>
          <Typography variant='body2' color='textSecondary'>
            {data.user || data._id}
          </Typography>
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={4}>
        <Typography variant='subtitle1'>Email</Typography>
        <Typography variant='body2' color='textSecondary'>
          {data.email}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <Typography variant='subtitle1'>Phone</Typography>
        <Typography variant='body2' color='textSecondary'>
          {data.phone || 'N/A'}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography variant='subtitle1'>Name</Typography>
        <Typography variant='body2' color='textSecondary'>
          {`${data.firstName || ''} ${data.lastName || ''}`.trim() || 'N/A'}
        </Typography>
      </Grid>
      {data.dealershipName && (
        <Grid item xs={12} sm={6}>
          <Typography variant='subtitle1'>Dealership Name</Typography>
          <Typography variant='body2' color='textSecondary'>
            {data.dealershipName}
          </Typography>
        </Grid>
      )}
      {data.dealershipBrand && (
        <Grid item xs={12} sm={6}>
          <Typography variant='subtitle1'>Dealership Brand</Typography>
          <Typography variant='body2' color='textSecondary'>
            {dealershipBrandsDict[data.dealershipBrand] || data.dealershipBrand}
          </Typography>
        </Grid>
      )}
    </>
  )
}

export default CustomerView
